import React from 'react';
import { store } from '../store';
import { extend } from 'lodash';
import { setMessage } from '../actions/systemMessage';

class SystemMessage extends React.Component {
  unsubscribe: ''

  state = {
    messageStatus: store.getState().systemMessage.messageStatus,
    message: store.getState().systemMessage.message
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(() =>
      this._setState()
    );
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  _setState() {
    this.setState(extend(this.state, {
      messageStatus: store.getState().systemMessage.messageStatus,
      message: store.getState().systemMessage.message
    }));
  }

  _wrapperClass() {
    if(this.state.messageStatus === 'success') {
      return 'system-message success'
    } else if(this.state.messageStatus === 'error') {
      return 'system-message error';
    } else {
      return 'system-message';
    }
  }

  _iconClass() {
    if(this.state.mesageStatus === 'success') {
      return 'fa fa-2x fa-check-circle float-xs-left notice-icon';
    } else {
      return 'fa fa-2x fa-exclamation-circle float-xs-left notice-icon';
    }
  }

  _close() {
    store.dispatch(setMessage('none', ''))
  }

  render() {
    return(
      <div className={this._wrapperClass()}>
        <div className="container">

          <span>
            <h3>
              <i className={this._iconClass()}></i>
              {this.state.message}
              <i className="fa fa-2x fa-times float-xs-right"
                 onClick={this._close}></i>
            </h3>
          </span>

        </div>
      </div>
    );
  }
}

export default SystemMessage



// WEBPACK FOOTER //
// ./src/components/SystemMessage.js